export default "__VITE_ASSET__yHGspxHL__"